import React from "react";

// Inline SVG logo for Lusi Błysk — sparkle + water drop motif
export const Logo = ({ className = "", light = false }) => {
  const navy = light ? "#ffffff" : "#083344";
  const sub = light ? "#a5f3fc" : "#0891b2";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <defs>
          <linearGradient id="lbDrop" x1="10" y1="4" x2="38" y2="44" gradientUnits="userSpaceOnUse">
            <stop stopColor="#67e8f9" />
            <stop offset="1" stopColor="#06b6d4" />
          </linearGradient>
        </defs>
        {/* water drop */}
        <path
          d="M24 3C24 3 9 20 9 30a15 15 0 1 0 30 0C39 20 24 3 24 3Z"
          fill="url(#lbDrop)"
        />
        {/* shine on drop */}
        <path
          d="M18 27c0-4 3-8 6-11"
          stroke="#ffffff"
          strokeWidth="2.5"
          strokeLinecap="round"
          opacity="0.85"
        />
        {/* sparkle */}
        <path
          d="M35 6l1.4 3.6L40 11l-3.6 1.4L35 16l-1.4-3.6L30 11l3.6-1.4L35 6Z"
          fill="#34d399"
        />
      </svg>
      <div className="leading-none">
        <span className="font-heading font-extrabold text-xl tracking-tight" style={{ color: navy }}>
          Lusi
        </span>
        <span className="font-heading font-extrabold text-xl tracking-tight" style={{ color: sub }}>
          {" "}Błysk
        </span>
        <div className="text-[10px] tracking-[0.2em] uppercase font-semibold mt-0.5" style={{ color: sub }}>
          Profesjonalne sprzątanie
        </div>
      </div>
    </div>
  );
};

export default Logo;
